export default "__VITE_ASSET__oQcYzjez__"